<h1 mat-dialog-title>Payment Authorization</h1>

<div mat-dialog-content class="pa-content">

  @if (!isDoItYourself) {
    <form [formGroup]="formPayeeInfo" autocomplete="off" class="pa-section">
      <p class="pa-question">Who do you authorize for payment?</p>

      <mat-radio-group
        id="payeeTypeCode"
        formControlName="payeeTypeCode"
        (change)="onChangeEventPayee($event)"
        aria-label="Select an option"
        class="pa-radio-group">

        <mat-radio-button [value]="'700000000'">
          {{ homeOwnerLabel }}
        </mat-radio-button>

        <mat-radio-button [value]="'700000001'">
          Contractor
        </mat-radio-button>

      </mat-radio-group>
    </form>
  } @else {
    <div class="pa-section">
      <h3 class="pa-subtitle">Do it myself retrofit</h3>
      <p class="pa-muted">You can authorize payment only for yourself.</p>
    </div>
  }

  @if (currentPayee) {
    <div class="pa-section pa-top-gap">

      @if (data.programType === 700000004 && currentPayee === 700000000) {
        <form [formGroup]="formPropertyInfo" autocomplete="off" class="pa-form">

          <mat-form-field appearance="outline" class="full">
            <mat-label>Property Owner Name</mat-label>
            <input matInput formControlName="pafFullName" maxlength="100" required />
            @if (onCheckPayeeControlValidators('pafFullName')) {
              <mat-error>Property Owner Name is required</mat-error>
            }
            @if (formPropertyInfo.get('pafFullName')?.value?.length >= 100) {
              <mat-hint>100 character limit</mat-hint>
            }
          </mat-form-field>

          <mat-form-field appearance="outline" class="full">
            <mat-label>Mailing Address</mat-label>
            <input matInput formControlName="pafAddressStreet" maxlength="100" required />
            @if (onCheckPayeeControlValidators('pafAddressStreet')) {
              <mat-error>Mailing address is required</mat-error>
            }
            @if (formPropertyInfo.get('pafAddressStreet')?.value?.length >= 100) {
              <mat-hint>100 character limit</mat-hint>
            }
          </mat-form-field>

          <mat-form-field appearance="outline" class="full">
            <mat-label>City</mat-label>
            <input matInput formControlName="pafAddressCity" maxlength="100" required />
            @if (onCheckPayeeControlValidators('pafAddressCity')) {
              <mat-error>City is required</mat-error>
            }
            @if (formPropertyInfo.get('pafAddressCity')?.value?.length >= 100) {
              <mat-hint>100 character limit</mat-hint>
            }
          </mat-form-field>

          <mat-form-field appearance="outline" class="full">
            <mat-label>State</mat-label>
            <input matInput formControlName="pafAddressState" required />
          </mat-form-field>

          <mat-form-field appearance="outline" class="full">
            <mat-label>ZIP Code</mat-label>
            <input matInput mask="99999" formControlName="pafAddressZip" maxlength="10" required />
            @if (onCheckPayeeControlValidators('pafAddressZip')) {
              <mat-error>ZIP Code is required</mat-error>
            }
            @if (formPropertyInfo.get('pafAddressZip')?.value?.length >= 10) {
              <mat-hint>Maximum 10 characters</mat-hint>
            }
          </mat-form-field>

        </form>
      }

      @if (data.programType !== 700000004 || (data.programType === 700000004 && currentPayee === 700000001)) {
        <div class="pa-readonly">
          @if (data.pafCompany?.length > 0) {
            <p class="pa-company">{{ data.pafCompany }}</p>
          }
          <p class="pa-name">{{ data.pafFullName }}</p>
          <address class="pa-address">
            {{ data.pafAddressStreet }}<br />
            {{ data.pafAddressCity }}, {{ data.pafAddressState }}<br />
            {{ data.pafAddressZip }}
          </address>
        </div>
      }

      <small class="pa-muted">
        Authorized on {{ currentDate.toLocaleDateString('en-US') }}
      </small>
    </div>
  } @else {
    <div class="pa-section pa-top-gap">
      <p class="pa-muted">
        Payment authorization is used to authorize to whom the program incentive payment is to be paid.
      </p>
    </div>
  }

</div>

<div mat-dialog-actions class="pa-actions">
  <button mat-button type="button" id="dialogPaFormCancelButton" (click)="onClickCancel()">
    Cancel
  </button>

  @if ((data.programType !== 700000004) || (data.programType === 700000004 && currentPayee === 700000001)) {
    <button
      mat-flat-button
      type="button"
      id="dialogPaFormSaveButton"
      color="primary"
      (click)="onClickSave()"
      [disabled]="((formPayeeInfo.pristine || formPayeeInfo.invalid) && !isDoItYourself)">
      Save
    </button>
  }

  @if (data.programType === 700000004 && currentPayee === 700000000) {
    <button
      mat-flat-button
      type="button"
      id="dialogPaFormSaveButton"
      color="primary"
      (click)="onClickSavePayeeInfo()"
      [disabled]="((formPayeeInfo.pristine || formPayeeInfo.invalid || formPropertyInfo.pristine || formPropertyInfo.invalid) && !isDoItYourself)">
      Save
    </button>
  }
</div>
